import { useInView } from "react-intersection-observer";
import { useTracking } from "../../../contexts/trackingContext";
import BoxItem from "./BoxItem";

const WidgetItem = ({ event, horizontal, trackView }) => {
	const { tracker } = useTracking();
	const { ref } = useInView({
		triggerOnce: true,
		skip: !trackView,
		onChange: (inView) => {
			if (trackView && inView) {
				tracker.trackEventView(event, "event_list");
			}
		},
	});

	return (
		<div
			className="c-card block row-span-2 relative overflow-hidden bg-white rounded border w-full @sm:max-w-lg m-auto"
			ref={ref}
		>
			<a href={event.absoluteHref} target="_top">
				<BoxItem event={event} horizontal={horizontal} />
			</a>
		</div>
	);
};

export default WidgetItem;
